// extracted by mini-css-extract-plugin
export default {"allocating":"List_allocating__N-0tG","actions":"List_actions__KIvec","button":"List_button__GpB0b"};